<script lang="ts" setup>
import type { ParsedToccoModuleFieldsFragment } from '~/types'

export interface ModuleProps {
  [key: string]: ParsedToccoModuleFieldsFragment[]
}

const props = defineProps<{
  title: string
  subtitle: string
  modules: ModuleProps
}>()

const modulesExist = computed(() => Object.keys(props.modules).length > 0)
</script>

<template>
  <SectionSpecial v-if="modulesExist" :title="title" :subtitle="subtitle" class="category">
    <ul class="cul">
      <li
        v-for="(group, index) in modules"
        :key="`modules-${index}`"
        v-animate="{ animation: 'vertical-reveal' }"
        class="group"
      >
        <ToccoModuleAddToCartDetails v-if="group[0]" :entity="group[0]" />
        <ul class="items cul">
          <li v-for="module in group" :key="`add-to-cart-${module.id}`">
            <ToccoModuleAddToCart :entity="module" />
          </li>
        </ul>
      </li>
    </ul>
  </SectionSpecial>
</template>

<style scoped lang="scss">
.category {
  margin-bottom: var(--margin);
}

.group {
  position: relative;
  display: block;

  &:not(:last-child) {
    margin-bottom: 40px;
  }

  @include breakpoint(tl) {
    display: grid;
    &:not(:last-child) {
      margin-bottom: 128px;
    }
  }
}
.items {
  &:hover {
    :deep(.item) {
      opacity: 0.5;
    }
  }
}
</style>
